import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const PlusIcon = ({ color = '#B5BCBD', size = '20px', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M14.763 6.653H9.067V1.284c0-.316-.128-.61-.342-.842a1.183 1.183 0 0 0-.853-.337c-.32 0-.619.127-.853.337a1.151 1.151 0 0 0-.342.842v5.369h-5.44c-.32 0-.618.126-.853.336a1.151 1.151 0 0 0-.341.843c0 .61.576 1.179 1.194 1.179h5.44v5.62c0 .316.128.611.342.843.234.231.533.337.853.337.32 0 .619-.127.853-.337.235-.232.342-.527.342-.842V9.01h5.696c.32 0 .618-.127.853-.337.235-.232.341-.527.341-.842 0-.316-.128-.61-.341-.843a1.278 1.278 0 0 0-.853-.336z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

PlusIcon.propTypes = propTypes;

export default PlusIcon;
